export enum Mask {
  DATE = '99.99.9999',
}
